
import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
    faSearch
} from '@fortawesome/free-solid-svg-icons';

import MultiSelectDropdown from '../components/dashboard/selectbox';
import Switch from '../components/dashboard/Switch';
import QuantitySelector from '../components/Quantity';
import '../global.css';
import '../components/Theme.css';
import './Form.css';
import ProgressBarLocal from "../components/ProgressBarLocal";
import SearchableSelect from "../components/SearchableSelect";
import AutoHeightTextarea from "../components/AutoHeightTextarea";
import TagsInput from "../components/TagsInput";
import InputMasking from "../components/InputMasking";
import IndianInputMasking from "../components/IndianInputMasking";
import CurrencyInput from "../components/CurrencyInput";
import CountryStateCitySelect from "../components/CountryStateCitySelect";
import AddMore from "../components/AddMore";


const Form = () =>{
    const options = [
        "Apple",
        "Banana",
        "Cherry",
        "Date",
        "Elderberry",
        "Fig",
        "Grape",
        "Honeydew",
    ];
    
    const [isSwitchOn, setIsSwitchOn] = useState(false);
    const toggleSwitch = () => setIsSwitchOn((prev) => !prev);


    return(
        <div className="container mt-6">
            <div className="card">
                <div className="card-header">
                    <h3 className="h5 mb-0">Column</h3>
                </div>
                <div className="card-body">
                    <div className="row align-items-center mb-4">
                        <div className="col-lg-2">
                            <label className="form-label form-label-sm">Small Label</label>
                        </div>
                        <div className="col-lg-10">
                            <input className="form-control input-sm" type="text" placeholder="Name..." />
                        </div>
                    </div>
                    <div className="row align-items-center mb-4">
                        <div className="col-lg-2">
                            <label className="form-label form-label-me">Medium Label</label>
                        </div>
                        <div className="col-lg-10">
                            <input className="form-control input-me" type="text" />
                        </div>
                    </div>
                    <div className="row align-items-center mb-4">
                        <div className="col-lg-2">
                            <label className="form-label form-label-lg">Large Label</label>
                        </div>
                        <div className="col-lg-10">
                            <input className="form-control input-lg" type="text" />
                        </div>
                    </div>
                    <div className="text-end">
                        <button class="btn btn-primary">Submit</button>
                        <button class="btn btn-danger ml-10">Cancel</button>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-6">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="h5 mb-0">Full Width</h3>
                        </div>
                        <div className="card-body">
                            <div className="form-group mb-4">
                                <label className="form-label">Name</label>
                                <input type="text" className="form-control input-lg" />
                            </div>
                            <div className="form-group mb-4">
                                <label className="form-label">Email ID</label>
                                <input type="email" className="form-control input-lg" />
                            </div>
                            <div className="form-group mb-4">
                                <label className="form-label">Password</label>
                                <input type="password" className="form-control input-lg" />
                            </div>
                            <button class="btn btn-primary">Submit</button>
                            <button class="btn btn-danger ml-10">Cancel</button>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="h5 mb-0">Animated</h3>
                        </div>
                        <div className="card-body">
                            <div className="form-group position-relative mb-4">
                                <input type="text" className="form-control input-lg input-animation" required />
                                <label className="form-label label-animation">Name</label>
                            </div>
                            <div className="form-group position-relative mb-4">
                                <input type="text" className="form-control input-lg input-animation" required />
                                <label className="form-label label-animation">Email ID</label>
                            </div>
                            <div className="form-group position-relative mb-4">
                                <input type="password" className="form-control input-lg input-animation" required />
                                <label className="form-label label-animation">Password</label>
                            </div>
                            <div className="form-group mb-4">
                                <div className="checkbox-section d-inline-block">
                                    <input className="checkbox" type="checkbox" id="checkbox-1" />
                                    <label className="form-label checkbox-label" for="checkbox-1">Remember Me</label>
                                </div>
                            </div>
                            <button class="btn btn-primary">Submit</button>
                            <button class="btn btn-danger ml-10">Cancel</button>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="h5 mb-0">Checkbox</h3>
                        </div>
                        <div className="card-body">
                            <div className="form-froup">
                                <div className="checkbox-section d-inline-block">
                                    <input className="checkbox" type="checkbox" id="checkbox-2" />
                                    <label className="form-label checkbox-label" for="checkbox-2">Checkbox 1</label>
                                </div>
                                <div className="checkbox-section d-inline-block">
                                    <input className="checkbox" type="checkbox" id="checkbox-3" />
                                    <label className="form-label checkbox-label" for="checkbox-3">Checkbox 2</label>
                                </div>
                                <div className="checkbox-section d-inline-block">
                                    <input className="checkbox" type="checkbox" id="checkbox-4" />
                                    <label className="form-label checkbox-label" for="checkbox-4">Checkbox 3</label>
                                </div>
                            </div>
                            <div className="form-froup mt-4">
                                <div className="form-checkbox">
                                    <input type="checkbox" id="check" name="check" value="" checked />
                                        <label for="check">
                                        <span></span>Checkbox
                                    </label>
                                </div>
                                <div className="form-checkbox">
                                    <input type="checkbox" id="check2" name="check" value="" />
                                        <label for="check2">
                                        <span></span>Checkbox
                                    </label>
                                </div>
                            </div>
                            <h5 className="h5 mt-4 mb-4">Radio Design 1</h5>
                            <div className="form-radio">
                                <div className="radio-inline mr-20">
                                    <input type="radio" id="demo-1" name="radio" value="demo_1"  />
                                    <label className="form-label" for="demo-1">Radio 1</label>
                                </div>
                                <div className="radio-inline mr-20">
                                    <input type="radio" id="demo-2" name="radio" value="demo_2" />
                                    <label className="form-label" for="demo-2">Radio 2</label>
                                </div>
                                <div className="radio-inline mr-20">
                                    <input type="radio" id="demo-3" name="radio" value="demo_3" />
                                    <label className="form-label" for="demo-3">Radio 3</label>
                                </div>
                            </div>
                            <h5 className="h5 mt-4 mb-4">Radio Design 2</h5>
                            <div className="form-radio">
                                <div className="radio-box">
                                    <input type="radio" id="featured-1" name="featured" checked />
                                    <label for="featured-1">Radio 1</label>
                                </div>
                                <div class="radio-box">
                                    <input type="radio" id="featured-2" name="featured" />
                                    <label for="featured-2">Radio 2</label>
                                </div>
                                    <div class="radio-box">
                                    <input type="radio" id="featured-3" name="featured" />
                                    <label for="featured-3">Radio 3</label>
                                </div>
                            </div>
                            <h5 className="h5 mt-4 mb-4">Search</h5>
                            <div className="form-group">
                                <label className="form-label form-label-me">Icon Right</label>
                                <div className="input-group">
                                    <input type="search" className="form-control input-me" placeholder="Search..." />
                                    <FontAwesomeIcon icon={faSearch} />
                                </div>
                            </div>
                            <div className="form-group mt-4">
                                <label className="form-label form-label-me">Icon Left</label>
                                <div className="input-group icon-left">
                                    <input type="search" className="form-control input-me" placeholder="Search..." />
                                    <FontAwesomeIcon icon={faSearch} />
                                </div>
                            </div>
                            <h5 className="h5 mt-4 mb-4">Color Input</h5>
                            <div className="form-group">
                                <input type="color" className="form-control" />
                            </div>
                            <div className="row align-items-center mt-4">
                                <div className="col-lg-4">
                                    <label className="form-label">From Date</label>
                                    <input type="date" className="form-control input-lg" />
                                </div>
                                <div className="col-lg-2 text-center">
                                    <label className="form-label m-0">To</label>
                                    {/* <input type="date" className="form-control" /> */}
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">To Date</label>
                                    <input type="date" className="form-control input-lg" />
                                </div>
                            </div>
                            <div className="form-group mt-4">
                                <label className="form-label">Month</label>
                                <input type="month" className="form-control input-lg" />
                            </div>
                            <div className="form-group mt-4">
                                <label className="form-label">Auto Height Textarea</label>
                                <AutoHeightTextarea />
                            </div>
                            <div className="form-group">
                                <label className="form-label">Number</label>
                                <input type="number" className="form-control input-lg" />
                            </div>
                            <div className="form-group mt-4">
                                <label className="form-label">Add More</label>
                                <AddMore />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="h5 mb-0">Select Box</h3>
                        </div>
                        <div className="card-body">
                            <div className="form-group">
                                <label className="form-label">Item</label>
                                <select className="form-control select_box">
                                    <option>Item 1</option>
                                    <option>Item 2</option>
                                    <option>Item 3</option>
                                </select>
                            </div>
                            <div className="form-group">
                                <MultiSelectDropdown />
                            </div>
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="form-group mt-4">
                                        <label className="form-label">Date</label>
                                        <input type="date" className="form-control" />
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="form-group mt-4">
                                        <label className="form-label">Time</label>
                                        <input type="time" className="form-control" />
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <div className="form-group mt-4">
                                        <label className="form-label">Message</label>
                                        <textarea className="form-control"></textarea>
                                    </div>
                                </div>
                                
                                <div className="col-lg-12 mt-4">
                                    <div className="form-group">
                                        <label className="form-label">File Upload</label>
                                        <input type="file" className="form-control" />
                                    </div>
                                </div>
                                <div className="col-lg-6 mt-4">
                                    <div className="form-group">
                                        <label className="form-label d-block">Qty</label>
                                        <QuantitySelector min={0} max={20} initial={1} />
                                    </div>
                                </div>
                                <div className="col-lg-6 mt-4">
                                    <div className="form-group mt-4">
                                        <Switch isOn={isSwitchOn} handleToggle={toggleSwitch} />
                                    </div>
                                </div>
                                <div className="col-lg-12 mt-4">
                                    <div className="form-group">
                                        <label className="form-label">Progress Bar</label>
                                        <ProgressBarLocal progress={100} color="#007bff" height="25px" />
                                        <ProgressBarLocal progress={30} color="#ff5733" height="25px" />
                                        <ProgressBarLocal progress={70} color="#28a745" height="25px" />
                                    </div>
                                </div>
                                <div className="col-lg-12 mt-4">
                                    <div className="form-group">
                                        <label className="form-label">Select with Search</label>
                                        <SearchableSelect class="form-control" options={options} />
                                    </div>
                                </div>
                                <div className="col-lg-12 mt-4">
                                    <div className="form-group">
                                        <label className="form-label">Tags Input</label>
                                        <TagsInput class="form-control" options={options} />
                                    </div>
                                </div>
                                <div className="col-lg-12 mt-4">
                                    <div className="form-group">
                                        <InputMasking mask="(XXX) XXX-XXXX" placeholder="(123) 456-7890" />
                                    </div>
                                </div>
                                <div className="col-lg-12 mt-4">
                                    <div className="form-group">
                                        <IndianInputMasking mask="(XXX) XXX-XXXX" placeholder="(123) 456-7890" />
                                    </div>
                                </div>
                                <div className="col-lg-12 mt-4">
                                    <div className="form-group">
                                        <CurrencyInput />
                                    </div>
                                </div>
                                <div className="col-lg-12 mt-4">
                                    <div className="form-label">Optgroup Select</div>
                                    <select class="form-control select_box input-lg">
                                        <optgroup label="Developer">
                                            <option value="AL">Mukesh Kumar</option>
                                            <option value="WY">Ravi Shankar</option>
                                        </optgroup>
                                        <optgroup label="Designer">
                                            <option value="WY">Pradeep Kumar</option>
                                            <option value="WY">Rohan Patil</option>
                                        </optgroup>
                                    </select>
                                </div>
                                <div className="col-lg-12 mt-4">
                                    <CountryStateCitySelect />
                                </div>
                                <div className="col-lg-12 mt-4">
                                    <button className="btn btn-primary">Submit</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Form;